<template>
    <v-container fluid grid-list-md class="horizontal-padding-content">
        <v-row>
            <v-col cols="12">
                <v-card class="rounded-card" height="100%">
                    <v-card-title class="primary--text pt-1 pb-0">
                        <v-row>
                            <v-col cols="12" class="text-uppercase primary--text text-center font-weight-black">
                                Referencias de pago
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                  :headers="headers"
                                  :items="records"
                                  :loading="loading"
                                  :sort-by="['date']"
                                  :sort-desc="[true]"
                                  multi-sort
                                  loading-text="Cargando datos"
                                  no-data-text="No hay datos para mostrar"
                                  :mobile-breakpoint="800"
                                  class="elevation-1">
                                    <template v-slot:[`item.action`]="{ item }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon color="black" v-on="on" @click="createPDF(item)">
                                                    <v-icon>mdi-printer</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Imprimir referencia</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.date`]="{ item }">
                                            {{ item.date | date }}
                                    </template>
                                    <template v-slot:[`item.ClientUser.firstName`]="{ item }">
                                            {{ item.ClientUser.firstName }} {{ item.ClientUser.lastName || '' }}
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ClientService from '@/services/ClientService'
import moment from 'moment-timezone'
import GenericService from '@/services/GenericService'
import Util from '@/common/utils.js'

export default {
  name: 'PaymentReferences',
  data () {
    return {
      records: [],
      loading: false,
      selected: {},
      headers: [
        {
          text: 'Creación',
          value: 'date',
          align: 'center',
          class: 'primary--text font-weight-black text-uppercase',
          sort: (a, b) => {
            if (a === b) {
              return 0
            } else {
              if (a < b) {
                return -1
              } else {
                return 1
              }
            }
          }
        },
        { text: 'Referencia', value: 'reference', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'No. de Facturas', value: 'count', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Generada por', value: 'ClientUser.firstName', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Acciones', value: 'action', align: 'center', class: 'primary--text font-weight-black text-uppercase' }
      ]
    }
  },

  beforeCreate () {
    if (!this.$store.getters.isLoggedIn) {
      const routeData = this.$router.resolve({ name: 'login' })
      window.open(routeData.href, '_self')
    }
  },

  mounted () {
    if (this.$store.getters.isLoggedIn) {
      this.loadRecords()
    }
  },

  methods: {
    async loadRecords () {
      const loader = this.$loading.show()
      this.loading = true
      try {
        const { data } = await ClientService.getPaymentReferences({
          clientId: this.$store.getters.user.clientId
        })
        this.records = data
        loader.hide()
        this.loading = false
      } catch (error) {
        loader.hide()
        console.error(error)
      }
    },

    async createPDF (record) {
      const loader = this.$loading.show()
      try {
        const data = await GenericService.downloadFile(`/client/payment-reference/${record.id}/base64`)
        const blob = Util.converBase64toBlob(data.base64, 'application/pdf')
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${record.reference}`
        loader.hide()
        link.click()
      } catch (error) {
        console.error(error)
        loader.hide()
        this.$swal('¡Error!', 'No se pudo generar el documento, contacta al administrador', 'error')
      }
    }
  },

  filters: {
    date (date) {
      return moment(date).local().format('DD-MMM-YYYY h:mm a')
    }
  }
}
</script>
<style>
    .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
        background: #ebf1f8!important;
    }
</style>
